import { render } from "./DeleteMsg.vue?vue&type=template&id=19ecd795"
import script from "./DeleteMsg.vue?vue&type=script&lang=js"
export * from "./DeleteMsg.vue?vue&type=script&lang=js"

import "./DeleteMsg.vue?vue&type=style&index=0&id=19ecd795&lang=css"

import exportComponent from "/home/marc/E09/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__